"use client";

import { useState } from "react";
import { BookingModal } from "@/components/BookingModal";

interface LocalLandingBookButtonProps {
  defaultService?: string;
  label?: string;
}

export function LocalLandingBookButton({
  defaultService,
  label = "Book a Consultation",
}: LocalLandingBookButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-block mt-6 bg-primary text-primary-foreground font-semibold px-6 py-3 rounded-xl hover:opacity-90 transition-opacity"
      >
        {label}
      </button>
      <BookingModal
        open={open}
        onOpenChange={setOpen}
        defaultService={defaultService}
      />
    </>
  );
}
